import { v4 as uuidv4 } from 'uuid';
import { MockPost } from '../models/MockPost';

export const mockPosts = [
    {
        id: uuidv4(),
        datetimestamp: "2011-10-05T14:48:00.000Z",
        eventType: "Event",
        type: "milestone",
        title: "Grading Module Completed",
        message: "The team took whatever it takes to finish the module for an impossible deadline!",
        readCount: 2,
        totalCount: 33,
        user: {
            name: "Roger J",
            initial: "R"
        }
    },
    {
        id: uuidv4(),
        datetimestamp: "2011-10-05T14:48:00.000Z",
        eventType: "Event",
        type: "milestone",
        title: "Grading Module Completed",
        message: "The team took whatever it takes to finish the module for an impossible deadline!",
        readCount: 2,
        totalCount: 33,
        user: {
            name: "Roger J",
            initial: "R"
        }
    },
    {
        id: uuidv4(),
        datetimestamp: "2011-10-05T14:48:00.000Z",
        eventType: "Event",
        type: "milestone",
        title: "Grading Module Completed",
        message: "The team took whatever it takes to finish the module for an impossible deadline!",
        readCount: 2,
        totalCount: 33,
        user: {
            name: "Roger J",
            initial: "R"
        }
    },
    {
        id: uuidv4(),
        datetimestamp: "2011-10-05T14:48:00.000Z",
        eventType: "Event",
        type: "milestone",
        title: "Grading Module Completed",
        message: "The team took whatever it takes to finish the module for an impossible deadline!",
        readCount: 2,
        totalCount: 33,
        user: {
            name: "Roger J",
            initial: "R"
        }
    },
    {
        id: uuidv4(),
        datetimestamp: "2011-10-05T14:48:00.000Z",
        eventType: "Event",
        type: "milestone",
        title: "Grading Module Completed",
        message: "The team took whatever it takes to finish the module for an impossible deadline!",
        readCount: 2,
        totalCount: 33,
        user: {
            name: "Roger J",
            initial: "R"
        }
    },
    {
        id: uuidv4(),
        datetimestamp: "2011-10-05T14:48:00.000Z",
        eventType: "Event",
        type: "milestone",
        title: "Grading Module Completed",
        message: "The team took whatever it takes to finish the module for an impossible deadline!",
        readCount: 2,
        totalCount: 33,
        user: {
            name: "Roger J",
            initial: "R"
        }
    },
    {
        id: uuidv4(),
        datetimestamp: "2011-10-05T14:48:00.000Z",
        eventType: "Event",
        type: "milestone",
        title: "Grading Module Completed",
        message: "The team took whatever it takes to finish the module for an impossible deadline!",
        readCount: 2,
        totalCount: 33,
        user: {
            name: "Roger J",
            initial: "R"
        }
    }
];

// mock company posts
export const mockCompanyPosts = [
    new MockPost({
        type: "Infrastructure - Operations",
        typeColor: "#E63946",
        message: "Infrastructure is not scalable. With additional customers coming on board recently and new ones coming on - issues with existing setup have surfaced.",
    }),
    new MockPost({
        type: "Infrastructure - Re-design",
        typeColor: "#457b9d",
        message: `Require Network Segmentation between environments. 
        Require scalable infrastructure to accommodate peak loads and additional resources.`
    }),
    new MockPost({
        type: "Application - Performance",
        typeColor: "#cb997e",
        message: ``
    }),
    new MockPost({
        type: "Database - Performance",
        typeColor: "#cb997e",
        message: ``
    }),
    new MockPost({
        type: "Scaling",
        typeColor: "#f4a261",
        message: `Bringing on new customers and understanding the volume
        they bring on to the site/environment.`
    }),
    new MockPost({
        type: "Product Resources",
        typeColor: "#ffb703",
        message: `Backlog of Projects to work on requiring product 
        resources to drive them forward
        Need stronger product resources`
    }),
    new MockPost({
        type: "Technical Debt",
        message: `Causes slower development, higher risk of issues. More manual testing. 
        Less robust solutions built in the past. Lack of separation of concerns.`
    }),
    new MockPost({
        type: "UI/UX Refresh Project",
        message: `Need to e-design the front-end to modern user experience 
        and frameworks to remove the JET technical debt.`
    }),
    new MockPost({
        type: "Files vulnerability",
        message: `Currently files with RCT Cloud can be accessed if you have the link to the file. 
        Proper access control doesn't exist. Need to do risk assessment of having this found by customers.`
    }),
    new MockPost({
        type: "Cincinnati Project",
        message: `New customer and large account - need to deliver flawlessly`
    }),
    new MockPost({
        type: "Employee Training(should tape sessions for re-use)",
        message: `Resources need business training
        Resources need training on how system works (specific workflows for certain customers)`
    }),
    new MockPost({
        type: "Quality of Product",
        message: `Better Business Requirements
        Stopping Regression(improve process)`
    }),
    new MockPost({
        type: "Customers at Risk of Churning(list them)",
        message: `Farm Mutual Re, Inact, GCNA, FCC, RSA, (localization), Pinnacol, BLS, BHHC`
    }),
    new MockPost({
        type: "Security Breach",
        message: `Need to be constantly monitoring environment and 
        systems to prevent any type of breaches/hacks.`
    }),
    new MockPost({
        type: "Compliance",
        message: `Always ensure we are in compliance with protocols that meet regulatory/industry/professional standards(SOC 2)`
    }),
    new MockPost({
        type: "High Performer Employee Churn",
        message: `Need to be identifying and monitoring High performers and their risk of leaving`
    }),
    new MockPost({
        type: "Reduce the time it takes to deploy releases",
        message: `Currently it's taking too long for customers to get the latest releases`
    }),
    new MockPost({
        type: "Competitve Feature threats"
    }),
    new MockPost({
        type: "SSO implementation",
        message: `Custom version of SSO doesn't follow industry best practices.(currently using a 
            self-signed certificate, also need to do impact assessment on it)`
    }),
    new MockPost({
        type: "Getting Bug fixes out in timely fashion"
    }),
    new MockPost({
        type: "Production Support Investigation",
        message: `Production Support Investigations required of developers often take them away from scheduled work they have with dates associated to them`
    }),
    new MockPost({
        type: "IE Browser Support"
    }),
    new MockPost({
        type: "Farm Re Account",
        message: `Farm Re has many tickets open and requests a lot of CRs -
        unsustainable to meet their expectations`
    }),
    new MockPost({
        type: "Customer Support Metrics"
    }),
    new MockPost({
        type: "Mobile App Support",
        message: `Tyler has communicated that he intends 
        to stop services with us`
    }),
    new MockPost({
        type: "Errors/Failures on the site",
        message: `Due to lack of logging, errors aren't being logged properly.`
    }),
    new MockPost({
        type: "Logging",
        message: `Lack of logging in the site makes troubleshooting 
        difficult and investigations take longer`
    }),
    new MockPost({
        type: "Return to work (office). Capacity/New Health & Safety Protocols",
        message: `Health and safety guidelines may force us to reconfigure the office.`
    }),
    new MockPost({
        type: "Localization",
        message: `500k + in revenue tied to the delivery of this in Q2 of 2021.`
    }),
    new MockPost({
        type: "Process for Invoicing and payment acceptance",
        message: `Always ensure proper process and protocol is followed`
    }),
];
